import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { executeIfLoggedIn } from '../../../../common/utils/logonUtils';
import RfeWebDialog from '../../../../common/utils/rfeWebDialog';
import { IOrderViewerMainStore } from '../../typing/stores';
import { NonAnonymousActions } from '../../utils/constants';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';
import { forwardRef } from 'react';

interface IAddToSharedLibraryButton {
	documentId?: number;
	orderId?: number;
	orderViewLogonUrl?: string;
}

const AddToSharedLibraryButton: React.ForwardRefExoticComponent<
	IAddToSharedLibraryButton & IActionButtonCommonProps & React.HTMLProps<HTMLButtonElement>
> = forwardRef((props, ref) => {
	const handler = () => {
		const params = new URLSearchParams();
		params.set('docids', `${props.documentId}`);
		params.set('orderId', `${props.orderId}`);

		executeIfLoggedIn(
			() => {
				RfeWebDialog.show(`library/sharedocsdlg.aspx?${params}`);
			},
			props.orderViewLogonUrl,
			NonAnonymousActions.AddToSharedLibrary
		);
	};

	return (
		<ActionButton
			label={localize('Add to shared library')}
			handler={handler}
			icon={Icons.ShareIcon}
			isPrimary={props.isPrimary}
			testId="add-to-shared-library-btn"
			controlledBy={props.controlledBy}
			ref={ref}
			className={props.className}
		/>
	);
});

AddToSharedLibraryButton.displayName = 'ActionButton';

export default inject((stores: IOrderViewerMainStore) => ({
	documentId: stores.orderViewerStore.viewModel.documentModel.documentId,
	orderId: stores.orderViewerStore.viewModel.orderId,
	orderViewLogonUrl: stores.orderViewerStore.viewModel.orderLogonViewerUrl.logonUrl
}))(AddToSharedLibraryButton);
